const state = () => {
  return {
    states: [],
    cities: [],
    counties: [],
    races: [],
    genders: [],
    testkits: [],
    howheard: [],
    clinics: [],
    mailingStates:[],
    mailingCities:[],
    mailingCounties:[],
    sexWiths:[],
    sexAtBirths:[]
  };
};

export default state;
